/**
 * Default-Sidebar-Konfiguration: Welche Tools über dem "Mehr"-Toggle
 * sichtbar sind, wenn der Nutzer noch keine Favoriten gesetzt hat.
 *
 * Reihenfolge der IDs = Anzeigereihenfolge in der Sidebar.
 */
export const DEFAULT_PRIMARY_TOOL_IDS = [
  'studio',
  'gallery',
  'text_generation',
  'amazon_listing_audit',
] as const;

export type DefaultPrimaryToolId = (typeof DEFAULT_PRIMARY_TOOL_IDS)[number];
